// Replaces js/src/templates/listings.html. Returns raw HTML as a string.
// Crucially: all dynamic values run through escapeHtml() so a malicious or
// malformed row from the API can't inject HTML into the page. The legacy
// underscore template used <%= %> which also escaped, but that guarantee
// is now explicit and local.

function escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function trimOrEmpty(s) {
  // The DB stores placeholder single-space strings for missing phone/email.
  // Treat any all-whitespace value as empty so we don't render a blank link.
  return typeof s === 'string' && s.trim() !== '' ? s.trim() : '';
}

function renderRow(rep, index) {
  const name   = escapeHtml(rep.name);
  const email  = trimOrEmpty(rep.email);
  const phone1 = trimOrEmpty(rep.phone1);
  const phone2 = trimOrEmpty(rep.phone2);

  const emailPart = email
    ? `<br><span class="email"><a href="mailto:${escapeHtml(email)}">${escapeHtml(email)}</a></span>`
    : '';
  const phone1Part = phone1
    ? `<br><span class="phone desktop" data-phone="${escapeHtml(phone1)}">${escapeHtml(phone1)}</span>`
    : '';
  const phone2Part = phone2
    ? `<br><span class="phone desktop" data-phone="${escapeHtml(phone2)}">${escapeHtml(phone2)}</span>`
    : '';

  return `
<div class="location row locations-listings--single locationContent loc${index + 1}">
  <p>
    <span class="index">${index + 1}</span>
    <span class="title">${name}</span>
    ${emailPart}
    ${phone1Part}
    ${phone2Part}
  </p>
</div>
`.trim();
}

export function listingsTemplate(data) {
  if (!Array.isArray(data)) return '';
  return data.map(renderRow).join('\n');
}
